// HeroSection.js
import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Logo from '../logo192.png';
const HeroSection = () => (
  <Container maxWidth="md" sx={{ py: 10, textAlign: 'center' }}>
    <Box component="img" src={Logo} alt="Logo de LUCHO" sx={{ width: 120, mb: 4 }} />
    <Typography variant="h2" component="h1">Bienvenido a LUCHO</Typography>
    <Typography variant="h5" color="text.secondary" sx={{ mt: 2 }}>
      Una aplicación web impulsada por inteligencia artificial que procesa la gestión de respuestas hospitalarias a procesos administrativos.
      LUCHO es un Líder Unificador de Cuentas HOspitalarias que facilita la ejecución de una amplía variedad de actividades que anteriormente
      se llevaban a cabo manualmente.
    </Typography>
  </Container>
);

export default HeroSection;
